import React, { useState } from "react"
import Carousel from "react-simply-carousel"
import MainTitle from "../MainTitle/MainTitle"
import "./styles.scss"

const RewardsCarousel = () => {
    const [activeSlideIndex, setActiveSlideIndex] = useState(null)

    return (
        <div className="rewards-carousel">
            <MainTitle>Other gifts</MainTitle>

            <Carousel
                containerProps={{
                    style: {
                        width: "100%",
                        justifyContent: "space-between"
                    }
                }}
                activeSlideIndex={activeSlideIndex}
                activeSlideProps={{
                    style: {
                        overflow: "hidden"
                    }
                }}
                onRequestChange={setActiveSlideIndex}
                forwardBtnProps={{
                    show: false
                }}
                backwardBtnProps={{
                    show: false
                }}
                responsiveProps={[
                    {
                        minWidth: 278,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 40px' : '0 0 0 28px'
                            }
                        }
                    },
                    {
                        minWidth: 318,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 70px' : '0 0 0 50px'
                            }
                        }
                    },
                    {
                        minWidth: 358,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 50px' : '0 0 0 30px'
                            }
                        }
                    },
                    {
                        minWidth: 410,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 75px' : '0 0 0 55px'
                            }
                        }
                    },
                    {
                        minWidth: 428,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 90px' : '0 0 0 70px'
                            }
                        }
                    },
                    {
                        minWidth: 500,
                        itemsListProps: {
                            style: {
                                padding: activeSlideIndex !== null ? '0 0 0 145px' : '0 0 0 100px'
                            }
                        }
                    }
                ]}
                dotsNav={{
                    show: true,
                    containerProps: {
                        style: {
                            width: 100,
                            justifyContent: 'space-between',
                            display: 'flex',
                            margin: '25px auto 10px'
                        },
                    },
                    itemBtnProps: {
                        style: {
                            height: 10,
                            width: 10,
                            borderRadius: "50%",
                            border: 0,
                            background: '#d9d9d9',
                            padding: 0
                        }
                    },
                    activeItemBtnProps: {
                        style: {
                            height: 10,
                            width: 25,
                            borderRadius: "20px",
                            border: 0,
                            background: "#fff"
                        }
                    }
                }}
                itemsToShow={2}
                speed={400}
            >
                <div className="reward-carousel">
                    <img src="https://assets.xela.co/taste/taa/55183d9e-7a15-4a15-98ef-26c20917ac54.png" alt="" />
                    <div className="title">
                        <p>Mob subscription from The Bear food truck by Disney+</p>
                    </div>
                </div>

                <div className="reward-carousel">
                    <img src="https://assets.xela.co/taste/taa/e3e29d7f-04f4-4673-b0c0-c4c4d2dcd557.png" alt="" />
                    <div className="title">
                        <p>20% Off Your First Order with Who Gives A Crap</p>
                    </div>
                </div>

                <div className="reward-carousel">
                    <img src="https://assets.xela.co/taste/taa/b4ba0e7a-6ca7-4864-ac20-a08ec02dda10.png" alt="" />
                    <div className="title">
                        <p>10 single Scoops of gelato</p>
                    </div>
                </div>

                <div className="reward-carousel">
                    <img src="https://assets.xela.co/taste/taa/ba6c6bbc-264d-4c23-bd07-002ca94fa6d0.png" alt="" />
                    <div className="title">
                        <p>A whole year of Sylt Pickling liquid</p>
                    </div>
                </div>

                <div className="reward-carousel">
                    <img src="https://assets.xela.co/taste/taa/69d73123-6595-412d-9254-07730adf732a.png" alt="" />
                    <div className="title">
                        <p>Korean Made Easy book from BOMBOM</p>
                    </div>
                </div>

                <div className="reward-carousel">
                    <img src={"https://assets.xela.co/taste/taa/f6f7526a-6b2c-4684-a624-a0bac69c59b1.png"} alt="" />
                    <div className="title">
                        <p>12-pack of Juno Bamboo Water & a free tote bag</p>
                    </div>
                </div>
            </Carousel>
        </div >
    )
}

export default RewardsCarousel
